import {css} from 'lit';
export const styles = css`:host {
  --height: 60px;
  --avatar-size: 40px;
  --bg: var(--gray-200);
  --bg-hover: var(--gray-300);
  --bg-active: var(--gray-400);
  --icon-bg-hover: var(--gray-400);
  --icon-bg-active: var(--gray-100);

  position: relative;
  display: flex;
  align-items: center;
  height: var(--height);
  padding-left: 8px;
  padding-right: 8px;
  background-color: var(--bg);
  border-radius: var(--border-radius);
}

aside {
  margin-right: 16px;
}

ef-img-placeholder {
  --background-primary: var(--gray-500);
  --text-primary: var(--gray-100);
}

main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1 auto;
  min-width: 1px;
}

a {
  min-width: 1px;
  color: inherit;
}

.actions {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.actions > *:not(:last-child) {
    margin-right: 6px;
  }

.actions .button-icon {
    border-radius: var(--border-radius);
  }

.actions .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: var(--font-size-md);
  }

::slotted(.xs-title-4) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

::slotted(.xs-title-4) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
}
`;
export default styles;
